import { render, staticRenderFns } from "./SalesDecomposition.vue?vue&type=template&id=280879b6&scoped=true&"
import script from "./SalesDecomposition.vue?vue&type=script&lang=js&"
export * from "./SalesDecomposition.vue?vue&type=script&lang=js&"
import style0 from "./SalesDecomposition.vue?vue&type=style&index=0&id=280879b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280879b6",
  null
  
)

export default component.exports